import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting/suggestions/scorecard`;
const rate = (h, t) => (t ? `${Math.round((h / t) * 100)}%` : '—');

// How past suggestions actually did; these results also tune future percentages.
export default function SuggestionsScorecard() {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(API).then((r) => setData(r.data)).catch(() => setData({ weeks: [], calibration: [] })); }, []);
  if (!data) return null;
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/70 p-3 space-y-2" data-testid="sugg-scorecard">
      <p className="text-sm font-bold text-white">Scorecard — how the suggestions did</p>
      {data.weeks.length === 0 ? (
        <p className="text-[11px] text-zinc-500" data-testid="sugg-scorecard-empty">
          No graded weeks yet. Suggestions are saved before kickoff and graded automatically after each game
          {data.pending ? ` (${data.pending} waiting)` : ''}. The hit rates then fine-tune future percentages.
        </p>
      ) : data.weeks.map((w) => (
        <div key={w.week} className="rounded-lg border border-zinc-800 p-2" data-testid={`sugg-scorecard-week-${w.week}`}>
          <p className="text-xs font-bold text-white">Week {w.week}: {w.hits}/{w.total} hit · {rate(w.hits, w.total)}</p>
          <div className="mt-1 flex flex-wrap gap-1">
            {Object.entries(w.by_stat).map(([k, v]) => (
              <span key={k} className="rounded border border-zinc-700 px-1.5 text-[10px] text-zinc-300">{k}: {v.hits}/{v.total} ({rate(v.hits, v.total)})</span>
            ))}
          </div>
          {w.misses.length > 0 && <p className="mt-1 text-[10px] text-red-300">Big misses: {w.misses.slice(0, 4).join(' · ')}</p>}
        </div>
      ))}
      {data.calibration.length > 0 && (
        <p className="text-[10px] text-zinc-500" data-testid="sugg-calibration">
          Calibration: {data.calibration.map((c) => `${c.range} predicted → ${Math.round(c.hit_rate * 100)}% actual (${c.n})`).join(' · ')}
        </p>
      )}
    </div>
  );
}
